import { css } from '@emotion/react';
import styled from 'types/theme.types';

export const SwitcherContainer = styled.div`
  background: var(--surface-main-cards);
  border-radius: 4px;
  border: 1px solid var(--border-primary);
  box-shadow: var(--shadow-dropdown);
  font-size: 13px;
  line-height: 17px;
  overflow: hidden;
`;

export const SwitcherItem = styled.div<{ selected?: boolean }>`
  cursor: pointer;
  height: 32px;
  display: flex;
  align-items: center;
  padding-right: 10px;
  font-weight: ${({ selected }) => (selected ? 'bold' : 'normal')};
  color: var(--text-heading);
  ${({ selected }) =>
    selected &&
    css`
      background: var(--surface-secondary-background);
    `}

  &:hover {
    background: var(--surface-main-element-on-card);
  }
`;

export const SwitcherRectangle = styled.div<{ selected?: boolean }>`
  height: 100%;
  width: 4px;
  margin-right: 5px;
  ${({ selected }) =>
    css`
      background: ${selected ? 'var(--surface-primary-action)' : 'transparent'};
    `}
`;
